import { useEffect } from 'react';

export default useResizeObserver;

/**
 * You can use this hook to watch for resize events on DOM elements.
 * The onresize argument is called with a single parameter: entries.
 * entries is a collection of the elements you passed in as ref.
 *
 * @param {object} ref React/DOM element ref
 * @param {function} onresize Called on resize events
 */
function useResizeObserver(ref: any, onresize: any): any {
  useEffect(() => {
    const observer = new ResizeObserver(onresize);

    if (ref.current) {
      const el = ref.current;
      observer.observe(el);
    }

    return (): any => observer.disconnect();
  }, [ref, onresize]);
}
